export const Constants = {
  SET_LOGIN_INFO: "SET_LOGIN_INFO",
  SET_LOGOUT: "SET_LOGOUT",
  SET_URL: "SET_URL",
  ADD_ITEM_TO_CART: "ADD_ITEM_TO_CART",
  INCREMENT_QUANTITY: "INCREMENT_QUANTITY",
  DECREMENT_QUANTITY: "DECREMENT_QUANTITY",
  EMPTY_CART: "EMPTY_CART",
  ADD_REST_DETAILS: "ADD_REST_DETAILS",
};
